import { render, staticRenderFns } from "./change-device.vue?vue&type=template&id=491d91e2&"
import script from "./change-device.vue?vue&type=script&lang=js&"
export * from "./change-device.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports